import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ElementTemplate } from '../../../Library/P.O.Template/TemplateComponent';
import { checkArray } from '../../../../Components/helper';
import { usePOTemplateOrderState } from '../AddPOTemplateProvider';

function EditFieldModal({ data, dataIndex, submit }) {
  const { setPOTemplateState } = usePOTemplateOrderState();
  const [array, setArray] = useState([]);
  const [obj, setObj] = useState(null);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (data?.forLabel) {
      setObj({ ...data });
    } else if (!isEmpty(data?.columns)) {
      const flatData = [...data.columns.flatMap((e) => e)];
      setArray(flatData.filter((item) => item.hasOwnProperty('label')));
    } else {
      setObj({ ...data });
    }
  }, [data]);

  const changetarget = (e, i, type) => {
    const updatedArray = [...array];
    updatedArray[i][type] = e.target.checked;
    setArray([...updatedArray]);
  };

  const handleCloseModel = () => {
    setArray([]);
    setObj(null);
    setPOTemplateState((otherStates) => ({
      ...otherStates,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupIndex: -1,
      editPopupParentIndex: -1,
      editPopupChildIndex: -1,
      // rigthColumn: updatedArray,
    }));
  };

  const onChange = (e, name, i) => {
    const object = { ...obj };
    switch (name) {
      case 'Label':
        object.label = e;
        break;
      case 'Placeholder':
        object.placeholder = e;
        break;
      case 'Required':
        object.required = e;
        break;
      case 'Enable':
        object.enable = e;
        break;

      default:
        object.options[i].name = e;
        break;
    }
    setObj({ ...object });
  };

  const addOption = () => {
    const object = { ...data };
    object.options?.push({ name: '' });
    setObj({ ...object });
  };

  const removeOption = (opi) => {
    const object = { ...data };
    object.options?.splice(opi, 1);
    setObj({ ...object });
  };
  const handleSubmit = () => {
    submit(obj || data, dataIndex);
    setArray([]);
    setObj(null);
    setPOTemplateState((otherStates) => ({
      ...otherStates,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupIndex: -1,
      editPopupParentIndex: -1,
      editPopupChildIndex: -1,
      // rigthColumn: updatedArray,
    }));
  };

  const mainBodyData = () => {
    return data?.type === 'container' ? (
      <>
        <span className="p-2 d-block f-14">{data?.label}</span>
        <table width="100%" className="field-tbl px-2 f-14">
          <thead>
            <th>{t('EDIT_FIELD_MODAL.LABEL')}</th>
            <th>{t('EDIT_FIELD_MODAL.ENABLE')}</th>
            <th>{t('EDIT_FIELD_MODAL.REQUIRED')}</th>
          </thead>
          <tbody>
            {checkArray(array) ? (
              array?.map((element, index) => {
                return (
                  <tr key={element?.label}>
                    <td>{element?.label}</td>
                    <td>
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="checkbox-label">
                          <input
                            type="checkbox"
                            id={`${element?.label}_${index}_Enable`}
                            name={element?.label}
                            checked={element?.enable}
                            onChange={(e) => changetarget(e, index, 'enable')}
                          />
                          <label htmlFor={`${element?.label}_${index}_Enable`} className="chklabel" />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="checkbox-label">
                          <input
                            type="checkbox"
                            id={`${element?.label}_${index}_Required`}
                            name={element?.label}
                            checked={element?.required}
                            onChange={(e) => changetarget(e, index, 'required')}
                          />
                          <label htmlFor={`${element?.label}_${index}_Required`} className="chklabel" />
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3}>
                  <span className="align-items-center justify-content-center d-flex">{`${t('EDIT_FIELD_MODAL.NO_ELEMENT_FOUND_IN')} ${data?.label}`}</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </>
    ) : (
      <>
        <strong className="p-2 d-block">{`${obj?.key.replace('_', ' ')} Properties`}</strong>
        <div className="px-2 mt-1">
          <ElementTemplate
            keys="Text"
            name={obj?.name || 'Text Box'}
            label={t('EDIT_FIELD_MODAL.LABEL')}
            placeHolder={t('EDIT_FIELD_MODAL.ENTER_TEXT')}
            value={obj?.label}
            onChange={onChange}
          />
        </div>
        <div className="px-2 mt-1">
          <ElementTemplate
            keys="Text"
            name={obj?.name || 'Text Box'}
            label={t('EDIT_FIELD_MODAL.PLACEHOLDER')}
            placeHolder={`${t('EDIT_FIELD_MODAL.PLACEHOLDER_FOR')} ${obj?.label}`}
            value={obj?.placeholder}
            onChange={onChange}
          />
        </div>
        <div className="px-2 mt-1">
          {obj?.options?.map((ele, i) => {
            return (
              <div className="d-flex" key={ele?.id}>
                <ElementTemplate
                  keys="Text"
                  name={ele?.name || 'Text Box'}
                  label={`${t('EDIT_FIELD_MODAL.LABEL_SELECTION_REQUIRED')} ${i + 1}`}
                  placeHolder={`${t('EDIT_FIELD_MODAL.LABEL_SELECTION_REQUIRED')} ${i + 1}`}
                  i={i}
                  value={ele?.name}
                  onChange={onChange}
                />
                {i + 1 === obj?.options?.length && (
                  <button className="btn btn-outline ml-auto mt-4" onClick={addOption} type="button">
                    <span className="icon-add" />
                  </button>
                )}
                {obj?.options?.length !== 1 && (
                  <button className="btn btn-outline mt-4" onClick={() => removeOption(i)} type="button">
                    <span className="icon-delete" />
                  </button>
                )}
              </div>
            );
          })}
        </div>
        <div className="px-2 mt-1">
          <div className="checkbox-label" key="enable_0">
            <input type="checkbox" id="enable_0" key="enable_0" name="Enable" checked={obj?.enable} onChange={(e) => onChange(e.target.checked, 'Enable', 0)} />
            <label htmlFor="enable_0" className="chklabel">
              <span>{t('EDIT_FIELD_MODAL.ENABLE')}</span>
            </label>
          </div>
          <div className="checkbox-label" key="require_1">
            <input
              type="checkbox"
              id="require_1"
              key="require_1"
              name="Required"
              checked={obj?.required}
              onChange={(e) => onChange(e.target.checked, 'Required', 1)}
            />
            <label htmlFor="require_1" className="chklabel">
              <span>{t('EDIT_FIELD_MODAL.REQUIRED')}</span>
            </label>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="right-section">
      <Card className="po-edit-right-card">
        <Card.Header className="d-flex">
          <span>{t('EDIT_FIELD_MODAL.FIELD_PROPERTY')}</span>
          <button
            name="close"
            onClick={() => {
              handleCloseModel();
            }}
            className="btn ml-auto"
            type="button"
          >
            <span className="icon-close cursor-pointer" />
          </button>
        </Card.Header>
        <Card.Body className="overflow-auto p-0 f-14">
          {data?.forLabel ? (
            <>
              <strong className="p-2 d-block">{t('EDIT_FIELD_MODAL.SECTION')}</strong>
              <div className="mt-1 p-2 d-block">
                <ElementTemplate
                  keys="Text"
                  name="Text Box"
                  label={t('EDIT_FIELD_MODAL.LABELS')}
                  placeHolder={t('EDIT_FIELD_MODAL.LABEL_SECTION')}
                  value={obj?.label}
                  onChange={onChange}
                />
              </div>
            </>
          ) : (
            mainBodyData()
          )}
        </Card.Body>
        <Card.Footer>
          <div className="w-100 d-flex align-items-center justify-content-center">
            <button className="btn btn-default bg-white" onClick={() => handleSubmit()} type="button">
              {t('SPEC_TEMP_LIBRARY.SAVE')}{' '}
            </button>
          </div>
        </Card.Footer>
      </Card>
    </div>
  );
}

export default EditFieldModal;
